import {useEffect, useState} from "react";
import axios from "axios";
import {API} from "../../helpers/constants";
import {enqueueSnackbar} from "notistack";
import {handleAxiosErrors} from "../../helpers/errorHandling";
import useUserData from "../user/useUserData";
import {useTranslation} from "react-i18next";
import {DASHBOARD} from "../../locales/components/namespaces";
import {normalizeOrderDetails} from "../../helpers/orders/normalizeOrderDetails";

const useOrderData =({id})=>{
    const [loading, setLoading] = useState(false);
    const [orderDetails, setOrderDetails] = useState([])
    const {token,language} = useUserData()
    const { t } = useTranslation(DASHBOARD);


    useEffect(()=>{
        setLoading(true)
        axios({
            method: 'get',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
            url: `${API}/en/brew/order/details?id=${id}`
        }).then((res) => {
            const data = res.data;
            const normalized = normalizeOrderDetails(data, language);

            setOrderDetails(normalized);
            setLoading(false);
        }).catch((error) => {
            setLoading(false)
            enqueueSnackbar(handleAxiosErrors(error, t('An error occurred!')), {
                variant: 'error',
                autoHideDuration: 3000,
            })
        })
    },[])
    return {
        loading,
        orderDetails
    }
}
export default useOrderData